import comp from "./RecentSearch";
export default comp;
